import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {semanticColor, sizing} from "@khanacademy/wonder-blocks-tokens";
import {ShimmerRectangle} from "@khan/component-shimmer";
import {usePrefersReducedMotion} from "@khan/data-prefers-reduced-motion";

import {Section} from "./section.tsx";

interface Props {
    headers?: string[];
    numberOfLoadingLines?: number;
    numberOfSections?: number;
}

export const SectionLoading: React.FC<Props> = ({
    headers = [],
    numberOfLoadingLines = 3,
    numberOfSections = 1,
}) => {
    const prefersReducedMotion = usePrefersReducedMotion();

    if (headers.length === 0 && numberOfSections > 0) {
        return (
            <View>
                {Array.from({length: numberOfSections}).map(
                    (_, sectionIndex) => (
                        <View
                            key={sectionIndex}
                            style={[styles.container, styles.section]}
                        >
                            <ShimmerRectangle
                                key={`shimmer-heading-${sectionIndex}`}
                                animated={!prefersReducedMotion}
                                style={{
                                    height: sizing.size_280,
                                    width: "30%",
                                    maxWidth: 800,
                                    marginBlockEnd: sizing.size_240,
                                }}
                            />
                            {Array.from({length: numberOfLoadingLines}).map(
                                (_, lineIndex) => (
                                    <ShimmerRectangle
                                        key={`shimmer-${sectionIndex}-${lineIndex}`}
                                        animated={!prefersReducedMotion}
                                        style={{
                                            height: sizing.size_200,
                                            width: "100%",
                                            maxWidth: 800,
                                            marginBlockEnd: sizing.size_080,
                                        }}
                                    />
                                ),
                            )}
                        </View>
                    ),
                )}
            </View>
        );
    }

    return (
        <View>
            {headers.map((header, sectionIndex) => (
                <Section
                    key={sectionIndex}
                    legendContent={header}
                    style={styles.section}
                    children={
                        <View>
                            {Array.from({length: numberOfLoadingLines}).map(
                                (_, lineIndex) => (
                                    <ShimmerRectangle
                                        key={`shimmer-${sectionIndex}-${lineIndex}`}
                                        animated={!prefersReducedMotion}
                                        style={{
                                            height: sizing.size_200,
                                            width: "100%",
                                            maxWidth: 800,
                                            marginBlockEnd: sizing.size_080,
                                        }}
                                    />
                                ),
                            )}
                        </View>
                    }
                />
            ))}
        </View>
    );
};
const styles = StyleSheet.create({
    container: {
        background: semanticColor.core.background.base.default,
        border: `1px solid ${semanticColor.core.border.neutral.subtle}`,
        borderRadius: sizing.size_080,
        padding: sizing.size_320,
        width: "100%",
        maxWidth: 800,
    },
    section: {
        marginBlockEnd: sizing.size_240,
    },
});
